module.exports = __webpack_public_path__ + "img/car-icon.008745de.svg";